/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgLoadingWaiting: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M12 17.62V21m-3.98-5.02l-2.38 2.38M6.38 12H3m2.64-6.36l2.38 2.38M12 6V3m4.77 4.23l1.59-1.59M21 12h-1.5m-1.14 6.36l-.53-.53"
            />
        </g>
    </svg>
);
